import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import facebook from '../../images/fb.png';
import instagram from '../../images/instagram.png';
import twitter from '../../images/twitter.png';
import tiktok from '../../images/tiktok.png';
import appleIcon from '../../images/apple-app-store.png';
import googlePlayIcon from '../../images/google-play.png';
import Slider from "react-slick";
import $ from 'jquery';
import { formatPrettyDate, beautyTime } from '../events/utils';
var socialIcons = {
  facebook: facebook,
  instagram: instagram,
  tiktok: tiktok,
  twitter: twitter
};
var PreviewEventSlider = /*#__PURE__*/function (_Component) {
  function PreviewEventSlider(props) {
    var _this;
    _classCallCheck(this, PreviewEventSlider);
    _this = _callSuper(this, PreviewEventSlider, [props]);
    _this.state = {
      loading: true,
      closing: false,
      showInstructions: false
    };
    _this.slideoutRef = /*#__PURE__*/React.createRef();
    _this.slideoutClose = /*#__PURE__*/React.createRef();
    _this.closeSlideout = _this.closeSlideout.bind(_this);
    _this.toggleShowInstructions = _this.toggleShowInstructions.bind(_this);
    _this.submitForm = _this.submitForm.bind(_this);
    return _this;
  }
  _inherits(PreviewEventSlider, _Component);
  return _createClass(PreviewEventSlider, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var self = this;
      document.body.classList.add('modal-open');
      setTimeout(function () {
        self.setState({
          loading: false
        });
      }, 10);
    }
  }, {
    key: "submitForm",
    value: function submitForm() {
      $('form.acf-form').submit();
    }
  }, {
    key: "toggleShowInstructions",
    value: function toggleShowInstructions() {
      this.setState({
        showInstructions: !this.state.showInstructions
      });
    }
  }, {
    key: "closeSlideout",
    value: function closeSlideout(event) {
      var self = this;
      if (this.slideoutRef && !this.slideoutRef.current.contains(event.target) || this.slideoutClose.current.contains(event.target)) {
        event.preventDefault();
        var timeout = window.screen.width < 768 ? 0 : 300;
        document.body.classList.remove('modal-open');
        this.setState({
          closing: true
        }, function () {
          setTimeout(function () {
            self.setState({
              closing: false
            });
            self.props.dismissPreviewModal();
          }, timeout);
        });
      }
      return;
    }
  }, {
    key: "render",
    value: function render() {
      var eventContent = this.props.eventContent;
      var _this$state = this.state,
        loading = _this$state.loading,
        closing = _this$state.closing,
        showInstructions = _this$state.showInstructions;
      var selectedTestDay = 1;
      var selectedEventType = 'durational';
      var borderColor = '#FEF200';
      if (eventContent) {
        if (eventContent.event_themes && eventContent.event_themes.length > 0) {
          borderColor = eventContent.event_themes[0].color ? eventContent.event_themes[0].color : '#FEF200';
        }
      }
      var settings = {
        dots: false,
        infinite: true,
        arrows: true,
        slidesToShow: 1,
        slidesToScroll: 1
      };
      var eventStatus = 'future';
      var rsvpLink = null;
      var rsvpLabel = 'RSVP';
      if (eventContent) {
        var today = new Date();
        if (selectedTestDay !== 1) {
          today = new Date(selectedTestDay + "T".concat(today.getHours(), ":").concat(today.getMinutes(), ":").concat(today.getSeconds()));
        }
        var eventStartDate = new Date(eventContent.date + 'T09:00:00');
        var eventEndDate = new Date(eventContent.date + 'T23:59:59');
        var weekStartDate = new Date('2020-11-14T09:00:00');
        rsvpLink = eventContent.rsvp ? eventContent.rsvp.url : null;
        // If IG event, set as follow us on IG
        if (eventContent.instagram_event) {
          rsvpLink = 'https://instagram.com/nycjewelryweek';
          rsvpLabel = 'Follow us to RSVP';
        }
        // If theres an RSVP link, set the label as its text
        if (eventContent.rsvp) {
          rsvpLabel = eventContent.rsvp.title ? eventContent.rsvp.title : 'RSVP';
        }
        // If the event is on now
        if (today > eventStartDate && today < eventEndDate || selectedEventType === 'durational' && today > weekStartDate) {
          eventStatus = 'present';
          rsvpLabel = 'Watch';
          if (eventContent.instagram_event) {
            rsvpLink = 'https://instagram.com/nycjewelryweek/live';
          } else {
            rsvpLink = 'https://youtube.com';
          }
          rsvpLink = eventContent.link ? eventContent.link.url : rsvpLink;
          if (eventContent.link) {
            rsvpLabel = eventContent.link.title ? eventContent.link.title : rsvpLabel;
            rsvpLink = eventContent.link.url;
          }
        }
        if (today > eventEndDate && selectedEventType !== 'durational') {
          eventStatus = 'past';
          rsvpLink = true;
          rsvpLabel = 'Event over';
        }
      }
      // If todays date is after the event end date
      return /*#__PURE__*/React.createElement("div", {
        id: "event-slideout",
        className: "".concat(loading ? 'loading' : '').concat(eventContent ? 'loaded' : '').concat(closing ? ' closing' : ''),
        onClick: this.closeSlideout
      }, /*#__PURE__*/React.createElement("div", {
        id: "event-slideout-wrapper",
        style: {
          borderColor: borderColor
        },
        ref: this.slideoutRef
      }, eventContent && /*#__PURE__*/React.createElement("div", {
        ref: this.slideoutClose,
        style: {
          borderColor: borderColor
        },
        onClick: this.closeSlideout,
        id: "close-slide"
      }, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("span", null, "Events"))), eventContent && /*#__PURE__*/React.createElement("div", {
        id: "event-slideout-content-wrapper",
        style: {
          paddingTop: 60
        }
      }, /*#__PURE__*/React.createElement("div", {
        id: "event-slideout-content"
      }, /*#__PURE__*/React.createElement("div", {
        className: "event-slideout-header"
      }, (eventContent.event_types || eventContent.event_themes.length > 0) && /*#__PURE__*/React.createElement("p", {
        className: "event-type"
      }, /*#__PURE__*/React.createElement("span", {
        style: {
          background: 'black',
          color: 'white'
        }
      }, eventContent.virtual_event), eventContent.event_types && /*#__PURE__*/React.createElement("span", {
        style: {
          background: '#fef200',
          color: 'black'
        }
      }, eventContent.event_types && eventContent.event_types.length > 0 ? eventContent.event_types[0].name : '')), /*#__PURE__*/React.createElement("h2", {
        dangerouslySetInnerHTML: {
          __html: eventContent.title ? eventContent.title : 'EVENT TITLE'
        }
      }), eventContent.subtitle && /*#__PURE__*/React.createElement("h3", null, eventContent.subtitle), eventContent.project_url && /*#__PURE__*/React.createElement("a", {
        className: "project-url bold uppercase text-button",
        style: {
          color: 'black',
          marginBottom: '1rem'
        },
        href: eventContent.project_url
      }, "Website"), eventContent.location_name && eventContent.virtual_event == 'irl' && /*#__PURE__*/React.createElement("p", {
        style: {
          marginBottom: 0
        }
      }, /*#__PURE__*/React.createElement("strong", null, eventContent.location_name)), eventContent.location_address && eventContent.virtual_event == 'irl' && /*#__PURE__*/React.createElement("p", {
        style: {
          marginTop: 0,
          marginBottom: 0
        }
      }, eventContent.location_address.address), eventContent.access_instructions && eventContent.virtual_event == 'irl' && /*#__PURE__*/React.createElement("div", {
        style: {
          marginBottom: '1.5rem'
        }
      }, /*#__PURE__*/React.createElement("sub", {
        onClick: this.toggleShowInstructions,
        style: {
          textTransform: 'uppercase',
          marginBottom: '1rem',
          fontWeight: 'bold',
          cursor: 'pointer'
        },
        className: "underlined"
      }, "Location Access Instructions"), showInstructions && /*#__PURE__*/React.createElement("p", null, eventContent.access_instructions)), eventContent.social.length > 0 && /*#__PURE__*/React.createElement("div", {
        className: "event-social"
      }, eventContent.social.map(function (social) {
        return /*#__PURE__*/React.createElement("a", {
          key: "social-".concat(social.type),
          className: "social-link social-".concat(social.type),
          target: "_blank",
          href: social.link
        }, /*#__PURE__*/React.createElement("img", {
          src: socialIcons[social.type]
        }));
      })), eventContent.images && /*#__PURE__*/React.createElement("div", {
        className: "item"
      }, /*#__PURE__*/React.createElement(Slider, _extends({
        className: "event-image-gallery"
      }, settings), eventContent.images.map(function (image) {
        return /*#__PURE__*/React.createElement("div", {
          key: image.id,
          className: "event-image-wrapper"
        }, /*#__PURE__*/React.createElement("div", {
          className: "event-image",
          role: "img"
          // aria-label={ image.alt }
          ,
          style: {
            backgroundImage: "url(".concat(image.src, ")")
          }
        }));
      }))), /*#__PURE__*/React.createElement("div", {
        className: "event-sub-header"
      }, eventContent.date && !eventContent.intro && eventContent.date.length === 1 && /*#__PURE__*/React.createElement("div", {
        className: "event-date"
      }, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("strong", null, formatPrettyDate(eventContent.date[0]), eventContent.end_date && " - ".concat(formatPrettyDate(eventContent.end_date)))), eventContent.start_time.length > 0 && /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("span", null, beautyTime(eventContent.start_time[0]), eventContent.end_time.length > 0 && "- ".concat(beautyTime(eventContent.end_time[0]))))))), eventContent.date.length > 1 && /*#__PURE__*/React.createElement("div", {
        className: "event-date",
        style: {
          marginBottom: '2rem'
        }
      }, /*#__PURE__*/React.createElement("h2", null, "Event Dates"), eventContent.date.map(function (date, ind) {
        return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", {
          style: {
            marginBottom: 0,
            marginTop: 0
          }
        }, /*#__PURE__*/React.createElement("strong", null, formatPrettyDate(date)), eventContent.start_time[ind] && /*#__PURE__*/React.createElement("span", {
          style: {
            marginLeft: '1rem'
          }
        }, beautyTime(eventContent.start_time[ind]), eventContent.end_time[ind] && "- ".concat(beautyTime(eventContent.end_time[ind])))));
      })), eventContent.content && /*#__PURE__*/React.createElement("div", {
        className: "event-content",
        dangerouslySetInnerHTML: {
          __html: eventContent.content
        }
      }), /*#__PURE__*/React.createElement("div", {
        className: "partner",
        style: {
          marginTop: '1.5rem'
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "partner-header"
      }, (eventContent.partnerName || eventContent.partner_website) && /*#__PURE__*/React.createElement("h3", null, eventContent.partner_name && /*#__PURE__*/React.createElement("span", null, eventContent.partner_name), eventContent.partner_website && /*#__PURE__*/React.createElement("a", {
        className: "uppercase",
        href: eventContent.partner_website,
        target: "_blank"
      }, "Website"))), (eventContent.partnerName || eventContent.partner_website) && /*#__PURE__*/React.createElement("div", {
        className: "underlined",
        style: {
          width: '100%'
        }
      }), eventContent.in_gesso && /*#__PURE__*/React.createElement("div", {
        className: "partner-info"
      }, /*#__PURE__*/React.createElement("div", {
        className: "partner-info-text"
      }, /*#__PURE__*/React.createElement("p", null, eventContent.partner_name ? eventContent.partner_name : 'This event', " is registered with Gesso. Download the app.")), /*#__PURE__*/React.createElement("div", {
        className: "partner-info-links-wrapper text-centered"
      }, /*#__PURE__*/React.createElement("div", {
        className: "partner-info-links"
      }, /*#__PURE__*/React.createElement("a", {
        target: "_blank",
        href: "https://play.google.com/store/apps/details?id=app.gesso.android&hl=en_US"
      }, /*#__PURE__*/React.createElement("img", {
        src: googlePlayIcon
      })), /*#__PURE__*/React.createElement("a", {
        target: "_blank",
        href: "https://apps.apple.com/ca/app/gesso-experiences/id1458855777"
      }, /*#__PURE__*/React.createElement("img", {
        src: appleIcon
      }))))), eventContent.in_shop_week && /*#__PURE__*/React.createElement("div", {
        className: "partner-info"
      }, /*#__PURE__*/React.createElement("div", {
        className: "partner-info-text"
      }, /*#__PURE__*/React.createElement("p", null, eventContent.partner_name ? eventContent.partner_name : 'This event', " is featured in our 'Shop The Week' page")), /*#__PURE__*/React.createElement("div", {
        className: "partner-info-links-wrapper text-centered"
      }, /*#__PURE__*/React.createElement("div", {
        className: "partner-info-links"
      }, /*#__PURE__*/React.createElement("a", {
        className: "btn",
        href: "https://nycjewelryweek.com/shop-the-week"
      }, "Shop The Week")))), eventContent.in_exhib && /*#__PURE__*/React.createElement("div", {
        className: "partner-info"
      }, /*#__PURE__*/React.createElement("div", {
        className: "partner-info-text"
      }, /*#__PURE__*/React.createElement("p", null, eventContent.partner_name ? eventContent.partner_name : 'This event', " is featured in our 'Exhibitionist' page")), /*#__PURE__*/React.createElement("div", {
        className: "partner-info-links-wrapper text-centered"
      }, /*#__PURE__*/React.createElement("div", {
        className: "partner-info-links"
      }, /*#__PURE__*/React.createElement("a", {
        className: "btn",
        href: "https://nycjewelryweek.com/exhibitionist"
      }, "Exhibitionist"))))), eventContent.participants && eventContent.participants.length > 0 ? /*#__PURE__*/React.createElement("div", {
        className: "event-participants"
      }, /*#__PURE__*/React.createElement("h4", {
        className: "underlined"
      }, "Participants"), /*#__PURE__*/React.createElement("ul", null, eventContent.participants.map(function (participant, index) {
        return /*#__PURE__*/React.createElement("li", {
          key: "participant-".concat(index)
        }, /*#__PURE__*/React.createElement("h5", null, participant.name), participant.bio && /*#__PURE__*/React.createElement("div", {
          className: "participant-bio",
          dangerouslySetInnerHTML: {
            __html: participant.bio
          }
        }));
      }))) : '', eventContent.supportEvents && eventContent.supportEvents.length > 1 ? /*#__PURE__*/React.createElement("div", {
        className: "event-participants"
      }, /*#__PURE__*/React.createElement("h4", {
        className: "underlined"
      }, "Supporting Events"), /*#__PURE__*/React.createElement("ul", null, eventContent.supportEvents.map(function (supportEvent, index) {
        return /*#__PURE__*/React.createElement("li", {
          key: "support-event-".concat(index)
        }, supportEvent.event_types && supportEvent.event_types.length > 0 && /*#__PURE__*/React.createElement("p", {
          className: "event-type"
        }, supportEvent.event_types && /*#__PURE__*/React.createElement("span", {
          style: {
            background: 'black',
            color: 'white'
          }
        }, supportEvent.event_types && supportEvent.event_types.length > 0 ? supportEvent.event_types[0].name : '')), supportEvent.event && supportEvent.event.length > 0 ? /*#__PURE__*/React.createElement("h5", null, supportEvent.event) : '', supportEvent.location && supportEvent.location.address && /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("strong", null, supportEvent.location.address)), supportEvent.url && /*#__PURE__*/React.createElement("a", {
          target: "_blank",
          href: supportEvent.url
        }, supportEvent.url), supportEvent.date && supportEvent.date.length > 1 && /*#__PURE__*/React.createElement("div", {
          className: "event-date"
        }, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("strong", null, formatPrettyDate(supportEvent.date))), supportEvent.start_time && /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("span", null, " ", "".concat(beautyTime(supportEvent.start_time), " - ").concat(beautyTime(supportEvent.end_time))))));
      }))) : '', /*#__PURE__*/React.createElement("div", {
        className: "text-centered follow-nycjw"
      }, /*#__PURE__*/React.createElement("a", {
        href: "https://instagram.com/nycjewelryweek",
        target: "_blank"
      }, /*#__PURE__*/React.createElement("img", {
        src: instagram
      }), /*#__PURE__*/React.createElement("span", null, "follow NYCJW on Instagram!")))), eventContent.isAvailableSubmit && /*#__PURE__*/React.createElement("div", {
        className: "text-centered"
      }, /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "btn btn-submit-event ".concat(eventContent.title && eventContent.title.length > 0 ? '' : 'disabled'),
        onClick: this.submitForm
      }, $('input[type="submit"]').val()))), loading && /*#__PURE__*/React.createElement("div", {
        className: "event-loading-wrapper"
      }, /*#__PURE__*/React.createElement("div", {
        className: "event-loading"
      }, "Loading"))));
    }
  }]);
}(Component);
export default PreviewEventSlider;